const BaseFrequency = require('@ordergroove/sdk/app/subscriptions/frequency').default;

const app = angular.module('msi.frequency.Frequency', []);

class Frequency extends BaseFrequency {
  get translatePeriodKey() {
    return `FREQ_PERIOD_TYPE_${this.period}`;
  }

  get translateEveryPeriodKey() {
    return `FREQ_EVERY_PERIOD_TYPE_${this.period}`;
  }

  /**
   * @deprecated We should use 'translatePeriodKey' instead since frequencies
   * localization strings are calculated using an expression.
   */
  get translateKey() {
    return `FREQ_${this.value}`;
  }

  /**
   * @deprecated We should use 'translateEveryPeriodKey' instead since frequencies
   * localization strings are calculated using an expression.
   */
  get everyTranslateKey() {
    return `FREQ_EVERY_${this.value}`;
  }

  get value() {
    return `${this.every}_${this.period}`;
  }

  static fromBase({ every, period } = {}) {
    return new Frequency(every, period);
  }
}

app.constant('Frequency', Frequency);

module.exports = app.name;
